import React from 'react'
import { IconButton } from '@material-ui/core'

const defaultSize = { height: 30, width: 30 }
const svgs = require.context('../../assets/images/bancos', false, /\.svg$/)

const logos = svgs.keys().reduce((acc, cur) => {
  const name = cur.replace('./', '').replace('.svg', '')
  acc[name] = svgs(cur)
  return acc
}, {})

export function Logo(props) {
  const logo = logos[props.bank]

  if (logo)
    return (
      <IconButton {...props}>
        <img
          src={logo.default}
          alt={props.bank}
          style={{
            height: defaultSize.height,
            width: defaultSize.width,
          }}
        />
      </IconButton>
    )
  else return null
}

export default Logo
